// Enregistre un Blob sur l'appareil (téléchargement déclenché par un clic).
export const saveBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Laisse le temps au navigateur de lancer le téléchargement avant de libérer l'URL.
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};
